export const roles = {
    MunicipalAdminRole: "urn:dk:fstyr:dla:ap:dla_ap_municipal_admin",
    SuperAdminRole: "urn:dk:fstyr:dla:ap:dla_ap_sup",
    CaseWorkerRole: "urn:dk:fstyr:dla:ap:dla_ap_municipal_caseworker"
};
